// extracted by mini-css-extract-plugin
module.exports = {"swap_page_container":"Swap_swap_page_container__1aTO8"};